const childrenLoaded = require('@alexspirgel/children-loaded');
require('./vendor/swiped-events.min.js');

class ComponentTestimonials extends HTMLDivElement {

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);
		this.initialize();
	}

	initialize() {

		if (this.initialized) {
			return;
		}
		this.initialized = true;

		if (this.slideElements) {
			for (let i = 0; i < this.slideElements.length; i++) {
				const slideElement = this.slideElements[i];
				slideElement.setAttribute('data-slide-position', i + 1);
			}
		}

		if (this.previousSlideButtonElement) {
			this.previousSlideButtonElement.addEventListener('click', this.previousSlide);
		}
		if (this.nextSlideButtonElement) {
			this.nextSlideButtonElement.addEventListener('click', this.nextSlide);
		}

		if (this.slidesContainerElement) {
			this.addEventListener('swiped', function(event) {
				if (event.detail.dir === 'left') {
					this.nextSlide();
				}
				if (event.detail.dir === 'right') {
					this.previousSlide();
				}
			});
		}

		console.log(this);

	}

	get slidesContainerElement() {
		return this.querySelector('.component-testimonials__testimonials');
	}

	get slideElements() {
		return this.querySelectorAll('.component-testimonials__testimonial');
	}

	get previousSlideButtonElement() {
		return this.querySelector('.component-testimonials__button-previous');
	}

	get nextSlideButtonElement() {
		return this.querySelector('.component-testimonials__button-next');
	}

	get isSlider() {
		if (window.matchMedia('(max-width: 80rem)').matches) {
			if (this.slideElements.length > 1) {
				return true;
			}
		}
		return false;
	}

	previousSlide = () => {
		if (this.isSlider) {
			for (const slideElement of this.slideElements) {
				const currentSlidePosition = parseInt(slideElement.getAttribute('data-slide-position'));
				slideElement.setAttribute('data-slide-direction', 'backward');
				if (currentSlidePosition >= this.slideElements.length) {
					slideElement.classList.add('transition-back-to-front');
					slideElement.setAttribute('data-slide-position', 1);
					setTimeout(() => {
						slideElement.classList.remove('transition-back-to-front');
					}, 750);
				}
				else {
					slideElement.setAttribute('data-slide-position', currentSlidePosition + 1);
				}
			}
		}
	}

	nextSlide = () => {
		if (this.isSlider) {
			for (const slideElement of this.slideElements) {
				const currentSlidePosition = parseInt(slideElement.getAttribute('data-slide-position'));
				slideElement.setAttribute('data-slide-direction', 'forward');
				if (currentSlidePosition <= 1) {
					slideElement.classList.add('transition-front-to-back');
					slideElement.setAttribute('data-slide-position', this.slideElements.length);
					setTimeout(() => {
						slideElement.classList.remove('transition-front-to-back');
					}, 750);
				}
				else {
					slideElement.setAttribute('data-slide-position', currentSlidePosition - 1);
				}
			}
		}
	}

}

customElements.define('component-testimonials', ComponentTestimonials, {extends: 'div'});